import { useState } from 'react';
import { faqs } from '@/mocks/faqs';
import SectionHeader from './SectionHeader';

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeader
          align="center"
          eyebrow="帮助中心"
          title="常见问题"
          desc="关于极速加载、翻页流畅与夜间模式，你想了解的都在这里。"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const active = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  active ? 'border-primary-300 bg-background-50' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(active ? -1 : i)}
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left cursor-pointer md:px-5"
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      active ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i className={`${active ? 'ri-subtract-line' : 'ri-add-line'} text-sm`}></i>
                  </span>
                </button>
                {active && (
                  <div className="border-t border-background-100 px-4 py-4 md:px-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}